import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
// import $ from '../node_modules/jquery';
// import Popper from '../node_modules/popper.js';
// import $ from '../node_mo/jquery/dist/jquery.js'


// import Popper  from '../node_modules/Popper.js'
import { ProSidebarProvider } from 'react-pro-sidebar';
// import "bootstrap";
import { store } from './Store/Store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


  <React.StrictMode>

    <Provider store={store}>
      <ProSidebarProvider>
      <BrowserRouter>
        <App />
        </BrowserRouter>
      </ProSidebarProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
